import { MINIMUM_DAYS_BEFORE_EVENT_FOR_REMINDER } from '@shared/components/ReminderModal/ReminderModal.constants';
import { useMemo } from 'react';

// Common hook for checking if event is within reminder window(at least 13 days before the event)
export const useEventWithinReminderWindow = (eventDate?: Date | null) => {
  return useMemo(() => {
    if (!eventDate) return true;

    const today = new Date();
    const thirteenDaysFromNow = new Date();
    thirteenDaysFromNow.setDate(today.getDate() + MINIMUM_DAYS_BEFORE_EVENT_FOR_REMINDER);

    return eventDate >= thirteenDaysFromNow;
  }, [eventDate]);
};
